<template>
  <div id="app" ref="app">
    <Top ref="top" />

    <div class="relative" ref="page-container">
      <transition name="fade">
        <div class="container" v-if="shouldShowProgressBar">
          <ProgressBar />
        </div>
      </transition>

      <transition
        :name="transitionName"
        appear
        mode="out-in"
        @before-leave="beforePageLeave"
        @enter="onPageEnter"
        @after-enter="afterPageEnter"
      >
        <router-view />
      </transition>
    </div>

    <Bottom ref="bottom" />
  </div>
</template>

<script>
import Bottom from "@/components/App/Bottom";
import Html from "@/lib/Html";
import ProgressBar from "@/components/Survey/ProgressBar";
import Top from "@/components/App/Top";

export default {
  components: {
    Bottom,
    ProgressBar,
    Top,
  },

  data() {
    return {
      prevRoute: null,
      transitionName: null,
      navigatingBackward: false,
      navigatingForward: false,
      prevHeight: null,
      showProgressBar: false,
      progressBarRoutes: [
        "survey.step-1",
        "survey.step-2",
        "survey.step-3",
        "survey.step-4",
      ],
    }
  },

  computed: {
    shouldShowProgressBar() {
      return this.showProgressBar && window._.includes(this.progressBarRoutes, this.$route.name);
    },
  },

  watch: {
    $route(to, from) {
      document.body.classList.remove(from.name);
      document.body.classList.add(to.name);
      this.prevRoute = from;

      if (to.meta.index > from.meta.index) {
        this.transitionName = "slide-left";
        this.navigatingBackward = false;
        this.navigatingForward = true;
      } else {
        this.transitionName = "slide-right";
        this.navigatingBackward = true;
        this.navigatingForward = false;
      }
    }
  },

  methods: {
    beforePageLeave(element) {
      this.prevHeight = Html.elementHeight(element);
    },

    onPageEnter(element) {
      this.showProgressBar = window._.includes(this.progressBarRoutes, this.$route.name);

      this.$nextTick(() => {
        let height = Html.elementHeight(element);

        element.style.height = this.prevHeight + "px";

        setTimeout(() => element.style.height = height + "px");
      });
    },

    afterPageEnter(element) {
      element.style.height = "auto";
    },
  },
}
</script>

<style lang="scss">
@import "./assets/scss/app";
</style>
